import {React, useEffect, useState} from 'react'
import { Link, Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useStateContext } from '../Views/Context/ContextProvider'
import { Badge, NavDropdown } from 'react-bootstrap';
import { FaBell, FaCalendarDay, FaCartPlus, FaHome, FaPowerOff, FaSignOutAlt, FaTh, FaChartLine, FaBox, FaStore, FaFileAlt } from "react-icons/fa";
import Sidebar from '../Views/offCanvas/Sidebar';
import Pusher from 'pusher-js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Switch from '@mui/material/Switch';
import axios from 'axios';
import Swal from 'sweetalert2';
import NetworkStatus from './NetworkStatus';

function DefaultLayout() {
  const navigation = useNavigate();
  const trackurl = useLocation();
  const [productAlert, setProductAlert] = useState([]);
  const productcount = productAlert.length;
  
  useEffect(() => {
    const pusher = new Pusher('34c32ee00edb72e40728', {
      cluster: 'ap2',
    });

    const channel = pusher.subscribe('productAlertChenel');
    channel.bind('productAlertEvent', (data) => {
      const object = {
        'productName': data.productName,
        'qty': data.qty,
        'id': data.id
      };
      setProductAlert(prevProductAlert => [...prevProductAlert, object]);
    });

    return () => {
      channel.unbind();
      channel.unsubscribe();
    };
  }, []);

  const { user, token, type, items, handleLogout } = useStateContext();
  const [isOffcan, setIsOffcan] = useState(false);
  const stringitems = JSON.parse(items);
  const [pos, setPos] = useState(localStorage.getItem('pos') || '0');

  const handleOffcanClose = (data) => {
    setIsOffcan(data);
  }

  const handleSubmitOffcan = () => {
    setIsOffcan(true);
  }

  const submitDayClose = () => {
    axios.get('/sanctum/csrf-cookie').then(res => {
      axios.get('api/stockdayclose').then(res => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: res.data,
          showConfirmButton: false,
          timer: 1500
        })
      })
    })
  }

  const checkAuthorized = async () => {
    try {
      const res = await axios.get('api/verify-token');
      return res.data;
    } catch (error) {
      return { authorized: false }
    }
  }

  useEffect(() => {
    const verify = async () => {
      const check = await checkAuthorized();
      if (check.authorized) {
        console.log('am authorized');
      } else {
        localStorage.removeItem('ACCESS_TOKEN');
        handleLogout();
        console.log('am unauthorized');
      }
    }
    verify();
  }, [trackurl, navigation, handleLogout])

  const submitLogout = () => {
    handleLogout();
  }

  const handlePosSetting = () => {
    const toggledPos = pos === '1' ? '0' : '1';
    if (toggledPos === '0') {
      toast.success('Switching To Thermal Printer', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.success('Switching To Invoice Printer', {
        position: "top-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setPos(toggledPos);
    localStorage.setItem('pos', toggledPos);
  }

  if (!token) {
    return <Navigate to='/login' />
  }

  if (type === 'Salesman') {
    return (
      <div className='salesman-container'>
        <div className='salesman-navbar'>
          <div className='salesman-brand'>
            <FaStore className='brand-icon' />
            <span>POS System</span>
          </div>
          <div className='salesman-menu'>
            <Link to={'reports'} className='salesman-nav-item'>
              <FaCalendarDay />
              <span>Reports</span>
            </Link>
            <Link to={'/'} className='salesman-nav-item'>
              <FaTh />
              <span>Dashboard</span>
            </Link>
            <Link to={'billdetail'} className='salesman-nav-item cart-item'>
              <FaCartPlus />
              <span>Cart</span>
              {stringitems && stringitems.length > 0 && (
                <Badge bg="danger" className='cart-badge'>{stringitems.length}</Badge>
              )}
            </Link>
            <button onClick={submitLogout} className='salesman-nav-item logout-btn'>
              <FaSignOutAlt />
              <span>Logout</span>
            </button>
          </div>
        </div>
        <div className='salesman-outlet'>
          <Outlet />
        </div>
        <style>{`
          .salesman-container {
            min-height: 100vh;
            background: #f5f7fa;
          }
          .salesman-navbar {
            background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
            padding: 0 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 60px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }
          .salesman-brand {
            display: flex;
            align-items: center;
            gap: 10px;
            color: white;
            font-size: 18px;
            font-weight: 600;
          }
          .brand-icon {
            font-size: 24px;
          }
          .salesman-menu {
            display: flex;
            gap: 20px;
            align-items: center;
          }
          .salesman-nav-item {
            display: flex;
            align-items: center;
            gap: 8px;
            color: white;
            text-decoration: none;
            padding: 8px 16px;
            border-radius: 8px;
            transition: all 0.3s ease;
            background: none;
            border: none;
            cursor: pointer;
            font-size: 14px;
          }
          .salesman-nav-item:hover {
            background: rgba(255,255,255,0.1);
            transform: translateY(-2px);
          }
          .cart-item {
            position: relative;
          }
          .cart-badge {
            position: absolute;
            top: -5px;
            right: -5px;
            font-size: 10px;
            padding: 2px 6px;
            border-radius: 50%;
          }
          .logout-btn {
            background: rgba(220, 53, 69, 0.2);
          }
          .logout-btn:hover {
            background: rgba(220, 53, 69, 0.3);
          }
          .salesman-outlet {
            background: white;
            min-height: calc(100vh - 60px);
          }
        `}</style>
      </div>
    )
  }

  return (
    <div className='dashboard-container'>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      
      <div className='dashboard-header'>
        <div className='header-left'>
          <button onClick={handleSubmitOffcan} className='menu-button'>
            <FaHome className='menu-icon' />
          </button>
          <Link to={'/'} className='dashboard-title'>
            <div className='title-wrapper'>
              <FaChartLine className='title-icon' />
              <span>Dashboard ({user} - {type})</span>
            </div>
          </Link>
        </div>

        <div className='header-right'>
          <div className='status-wrapper'>
            <NetworkStatus />
          </div>
          
          <div className='printer-switch'>
            <span className='switch-label'>Printer Mode</span>
            <Switch 
              color="info" 
              checked={pos === '1'} 
              onClick={handlePosSetting}
              className='custom-switch'
            />
          </div>
          
          <div className='notification-wrapper'>
            {productcount > 0 && (
              <div className='notification-badge'>
                <span>{productcount}</span>
              </div>
            )}
            <NavDropdown 
              title={<FaBell className='bell-icon' />} 
              id="basic-nav-dropdown"
              className='custom-dropdown'
            >
              {productAlert.slice().reverse().map((item, index) => (
                <NavDropdown.Item key={item.id}>
                  <Link to={'/add/product'} className='notification-item'>
                    <FaBox className='notification-icon' />
                    <div className='notification-content'>
                      <strong>{item.productName}</strong>
                      <span>Left quantity: {item.qty} items</span>
                    </div>
                  </Link>
                </NavDropdown.Item>
              ))}
              {productAlert.length === 0 && (
                <div className='no-notifications'>No notifications</div>
              )}
            </NavDropdown>
          </div>

          <NavDropdown 
            title={<FaPowerOff className='power-icon' />} 
            id="basic-nav-dropdown"
            className='custom-dropdown'
          >
            <NavDropdown.Item onClick={submitLogout} className='dropdown-item'>
              <FaSignOutAlt /> Logout
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={submitDayClose} className='dropdown-item'>
              <FaFileAlt /> Day Close
            </NavDropdown.Item>
          </NavDropdown>
        </div>
      </div>

      <div className='dashboard-outlet'>
        <Outlet />
      </div>

      {isOffcan && <Sidebar show={isOffcan} onChildOffcanClose={handleOffcanClose} />}

      <style>{`
        .dashboard-container {
          min-height: 100vh;
          background: #f5f7fa;
        }
        
        .dashboard-header {
          background: white;
          padding: 12px 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-shadow: 0 2px 15px rgba(0,0,0,0.08);
          position: sticky;
          top: 0;
          z-index: 1000;
          backdrop-filter: blur(10px);
          background: rgba(255,255,255,0.95);
        }
        
        .header-left {
          display: flex;
          align-items: center;
          gap: 20px;
        }
        
        .menu-button {
          background: none;
          border: none;
          cursor: pointer;
          padding: 8px;
          border-radius: 10px;
          transition: all 0.3s ease;
        }
        
        .menu-button:hover {
          background: rgba(0,0,0,0.05);
          transform: scale(1.05);
        }
        
        .menu-icon {
          color: #1e3c72;
          font-size: 22px;
        }
        
        .dashboard-title {
          text-decoration: none;
        }
        
        .title-wrapper {
          display: flex;
          align-items: center;
          gap: 10px;
          color: #1e3c72;
          font-size: 18px;
          font-weight: 600;
          padding: 8px 16px;
          border-radius: 10px;
          transition: all 0.3s ease;
        }
        
        .title-wrapper:hover {
          background: linear-gradient(135deg, rgba(30,60,114,0.1) 0%, rgba(42,82,152,0.1) 100%);
        }
        
        .title-icon {
          font-size: 20px;
        }
        
        .header-right {
          display: flex;
          align-items: center;
          gap: 20px;
        }
        
        .status-wrapper {
          background: #f8f9fa;
          padding: 6px 12px;
          border-radius: 20px;
        }
        
        .printer-switch {
          display: flex;
          align-items: center;
          gap: 10px;
          background: #f8f9fa;
          padding: 6px 15px;
          border-radius: 30px;
        }
        
        .switch-label {
          font-size: 13px;
          color: #666;
          font-weight: 500;
        }
        
        .notification-wrapper {
          position: relative;
        }
        
        .notification-badge {
          position: absolute;
          top: -5px;
          right: -5px;
          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
          color: white;
          border-radius: 50%;
          width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          font-weight: bold;
          z-index: 1;
        }
        
        .bell-icon, .power-icon {
          font-size: 20px;
          color: #1e3c72;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .bell-icon:hover, .power-icon:hover {
          transform: scale(1.1);
        }
        
        .dashboard-outlet {
          background: white;
          min-height: calc(100vh - 70px);
          padding: 20px;
        }
        
        .notification-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px;
          text-decoration: none;
          color: #333;
          transition: all 0.3s ease;
        }
        
        .notification-item:hover {
          background: #f8f9fa;
          transform: translateX(5px);
        }
        
        .notification-icon {
          color: #ffc107;
          font-size: 16px;
        }
        
        .notification-content {
          display: flex;
          flex-direction: column;
          gap: 3px;
        }
        
        .notification-content strong {
          font-size: 13px;
        }
        
        .notification-content span {
          font-size: 11px;
          color: #666;
        }
        
        .no-notifications {
          padding: 20px;
          text-align: center;
          color: #999;
          font-size: 13px;
        }
        
        .dropdown-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 20px;
        }
        
        @media (max-width: 768px) {
          .dashboard-header {
            padding: 10px 15px;
          }
          
          .title-wrapper span {
            display: none;
          }
          
          .printer-switch {
            padding: 4px 10px;
          }
          
          .switch-label {
            display: none;
          }
          
          .dashboard-outlet {
            padding: 15px;
          }
        }
      `}</style>
    </div>
  )
}

export default DefaultLayout